import { pipe } from 'lib/util'
import { modelComposition } from 'trait/composition'

const descriptor = 'model::toBeValidated'

export default pipe(
  modelComposition(descriptor),
)
